import React, { useEffect, useState } from 'react';
import { helpers, types } from '../../../utilities'
import FeatherIcon from 'feather-icons-react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { UserInitials } from 'components/utilities';
import { useConfig } from 'utilities/variables/configContext';




import { 
  setActivelink, 
  fixedHeaderSpace,
  setupWindowResizeListener, 
  coverimg,
  initSidebar,
} from '../../utilities/domFunctions';

import {
  mAndroidSimpleLogo,
  windowsLogo,
  ubuntuLogo,
} from '../../../assets/images';


interface MobileHeaderProps {
    userAttributes: types.IAccountUserAttributes | null;
    handleSignOut: (event: React.MouseEvent) => Promise<void>;
    product: any;
    products: any;
    setShowLocationModal: any
  }

export const MobileHeaderPhone: React.FC<MobileHeaderProps> = ({ userAttributes, handleSignOut,  product, products, setShowLocationModal }) => {

  const { config } = useConfig();
  const [productName, setpoductName] = useState<string>();

  useEffect(() => {
    initSidebar();
    setActivelink();
    fixedHeaderSpace();
    setupWindowResizeListener();
    coverimg();
  }, []);

  useEffect(() => {
    if (product && product.screendimension) {
      const [width, height] = product.screendimension.split('x');
      const fullWindow = document.getElementById('cartdroppable-fullwindow');
      const windowHeight = (parseInt(height) + 82);
      if (fullWindow) {
        fullWindow.style.width = `${width}px`;
        fullWindow.style.height = `${height}px`;
        window.resizeTo(parseInt(width), windowHeight);
      }
    }
    if (product && product.tags && product.tags['kname']) {
      const key = Object.keys(product.tags).find(k => k.startsWith('kname'));
      setpoductName(key ? product.tags[key] : '')                        
    }
  }, [product]);

  const handleOpenProductWindow = (prodSelected: any, event?: React.MouseEvent, openInNewWindow = true) => {
    event && event.preventDefault();
    
    // const url = prodUrl; // Replace with your desired URL
    const url = `${config.WEB_APP_URL}/product-window?productId=${prodSelected.id}`
    helpers.logToOutput('handleOpenProductWindow url:', url);

    if (openInNewWindow) {
      let windowName = '';
    
      // Generate a unique name for the window using a timestamp or random number
      if (prodSelected.tags.kshortTitle && (prodSelected.tags.kshortTitle == 'SH') ) {
        windowName = `Terminal - ${Date.now()}`;
      } else {
        windowName = prodSelected.tags.kname;
      }

      // Define the window features (size, position, etc.)
      const windowFeatures = 'width=800,height=600, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no';
    
      // Open a new window with the specified URL, unique name, and features
      const newWindow = window.open(url, windowName, windowFeatures);
    
      // Check if the new window was successfully opened
      if (newWindow) {
        // You can perform additional actions if needed
        // For example, you can pass data to the new window using the window.opener property
        newWindow.opener.postMessage(prodSelected, '*');
      } else {
        // Handle the case where the window couldn't be opened (e.g., due to popup blockers)
        alert('The window could not be opened. Please check your popup blocker settings.');
      }
    } else {
      window.location.href = url;
    }
  }


  return (
    <>
      <header className="adminuiux-header">
        {/* Fixed navbar */}
        <nav className="navbar navbar-expand-lg fixed-top icon-wrapper">
          <div className="container-fluid k-custom-centre">
            {userAttributes &&
              <div className="dropdown d-inline-block">
                <a href="#" className="dropdown-toggle btn btn-link btn-square btn-link-header style-none no-caret px-0" id="userprofiledd" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                  <div className="row gx-0 d-inline-flex">
                    <div className="col-auto align-self-center">
                      <figure className="avatar coverimg align-middle">
                        <UserInitials input={userAttributes && userAttributes.displayName} backgroundColor="white" width="28px" height="28px" fontSize="12px" color="black" border="1px solid black" marginRight='0px' />
                      </figure>
                    </div>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-center width-300 pt-0 px-0" aria-labelledby="userprofiledd">
                  <div className="bg-theme-1-space rounded py-2 mb-3 dropdown-dontclose">
                    <div className="row gx-0">
                      <div className="col-auto px-3">
                        <div className="avatar coverimg align-middle">
                          <UserInitials input={userAttributes && userAttributes.displayName} backgroundColor="white" width="40px" height="40px" fontSize="20px" color="black" border="1px solid black" marginRight='0px' />
                        </div>
                      </div>
                      <div className="col align-self-center ">
                        <p className="mb-1"><span>{userAttributes.displayName}</span></p>
                        <p className='k-mt-min-10'><small className="opacity-50">{userAttributes.identifier}</small>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="px-2">
                    <div className='mb-1'>
                      <a href="/" className="dropdown-item"> 
                        <FeatherIcon className="avatar avatar-18 me-1" icon="x-circle" />
                          Close
                      </a>
                    </div>
                    
                    <div className='mb-1'>
                      <a href="/" 
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowLocationModal(false);
                        }}> 
                        <FeatherIcon className="avatar avatar-18 me-1" icon="map-pin" style={{opacity: 0.2, cursor: 'default'}} />
                        <span style={{opacity: 0.2, cursor: 'default'}}>Set Location</span>
                      </a>
                    </div>

                    <div className='mb-1'>
                      <a className="dropdown-item"> 
                        <FeatherIcon className="avatar avatar-18 me-1" icon="upload-cloud" style={{opacity: 0.2, cursor: 'default'}} />
                        <span style={{opacity: 0.2, cursor: 'default'}}>
                            Change IP Address
                        </span>
                      </a>
                    </div>
                    
                    <div className="dropdown open-left dropdown-dontclose" onClick={(e) => e.stopPropagation()}>
                      <a className="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                        <div className="row gx-3">
                          <div className="col"><FeatherIcon className="avatar avatar-18 me-1" icon="smartphone" />Change Device</div>
                          <div className="col-auto">
                            <small className="vm">{productName}</small>
                          </div>
                          <div className="col-auto"><span className="arrow bi bi-chevron-right"></span></div>
                        </div>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end" onClick={(e) => e.stopPropagation()}>
                        <div className="">
                          {products ? (
                            products
                              .filter((prod: types.IApiProduct) => {
                                const key = Object.keys(prod.tags).find(k => k.startsWith('kname'));
                                return key ? prod.tags[key] !== productName : true;
                              })
                              .sort((a: any, b: any) =>
                                a.tags['kname'].localeCompare(b.tags['kname'])
                              )
                              .map((prod: types.IApiProduct) => (
                                <div key={prod.id}>
                                  <a
                                    className={`dropdown-item ${prod.state !== 'running' ? 'text-muted' : ''}`}
                                    onClick={prod.state === 'running' ? (e) => handleOpenProductWindow(prod, e, false) : undefined}
                                    style={{
                                      pointerEvents: prod.state === 'running' ? 'auto' : 'none',
                                      opacity: prod.state === 'running' ? 1 : 0.5
                                    }}
                                  >
                                    <img
                                      className="me-2"
                                      style={{ width: '15px', filter: prod.state !== 'running' ? 'grayscale(100%)' : 'none' }}
                                      src={
                                        prod?.os.toLowerCase() === 'windows'
                                          ? windowsLogo
                                          : prod?.os.toLowerCase() === 'ubuntu'
                                            ? ubuntuLogo
                                            : prod?.os.toLowerCase() === 'android'
                                              ? mAndroidSimpleLogo
                                              : undefined
                                      }
                                    />
                                    {(() => {
                                      const key = Object.keys(prod.tags).find(k => k.startsWith('kname'));
                                      return key ? prod.tags[key] : '';
                                    })()}
                                  </a>
                                </div>
                              ))
                          ) : (
                            <div><a className="dropdown-item" data-value="loading">Loading ...</a></div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      <a className="dropdown-item theme-red mt-2" onClick={handleSignOut}> 
                        <FeatherIcon className="avatar avatar-18 me-1" icon="power" />
                          Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </nav>
      </header>
    </>
  )

}